const googleMapsLib = ({ apiKey, version = null }) => `
  (g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src='https://maps.googleapis.com/maps/api/js?'+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
    key: "${apiKey}",
    v: "${version || 3}",
    language: "it",
  });
`;

export const addGoogleMapsLib = async ({ apiKey, version }) => {
  if (window.google && window.google.maps) return true;

  const code = googleMapsLib({ apiKey, version });
  const s = document.createElement('script');
  s.type = 'text/javascript';

  try {
    s.appendChild(document.createTextNode(code));
    document.body.appendChild(s);
  } catch (e) {
    s.text = code;
    document.body.appendChild(s);
  }

  const checkIfLibIsLoaded = new Promise((resolve) => {
    if (window.google && window.google.maps) {
      resolve(true);
    } else {
      const wait = setInterval(() => {
        if (window.google && window.google.maps) {
          clearInterval(wait);
          resolve(true);
        }
      }, 100);
    }
  });

  const isLibLoaded = await checkIfLibIsLoaded;
  return isLibLoaded;
};

export default googleMapsLib;
